import Grid from "@mui/material/Grid";
import {Divider} from "@mui/material";
import PickRowReverseTopMoments from "../PickRowReverseTopMoments";
import Paper from "@mui/material/Paper";
import {TwoWidePickBlockTopMomentsProps, seedForCompetitor} from "./PickBlockTopMoments";

export default function PickBlockReverseTopMoments({pick, result, updatePick, picks_locked, qualifiers}: Readonly<TwoWidePickBlockTopMomentsProps>){
    const seed1 = seedForCompetitor(1, pick, result, qualifiers);
    const seed2 = seedForCompetitor(2, pick, result, qualifiers);
    return (
        <Grid container component={Paper} m={1} sx={{
            display: 'flex',
            flexDirection: "column",
            height: 'fit-content',
            width: 'fit-content',
        }}>
            <PickRowReverseTopMoments
                competitor_number={1}
                pick={pick}
                result={result}
                onClick={updatePick}
                picks_locked={picks_locked}
                fourWide={false}
                seed={seed1}
            />
            <Divider/>
            <PickRowReverseTopMoments
                competitor_number={2}
                pick={pick}
                result={result}
                onClick={updatePick}
                picks_locked={picks_locked}
                fourWide={false}
                seed={seed2}
            />
        </Grid>
    )
}
